import { SearchResponse } from './search.interfaces';

export interface SearchWikiResponse extends SearchResponse {
  url?: string;
  linkText?: string;
}
